// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum ElevatorDesignTypes {
  CallButton = 0,
  IO = 1,
  Software = 2,
}
